module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.ts");
  /******/
}
/************************************************************************/

/******/
({
  /***/
  "./src/contracts/weapiEventPayload.ts":
  /***/
  function srcContractsWeapiEventPayloadTs(module, exports) {
    /***/
  },

  /***/
  "./src/index.ts":
  /***/
  function srcIndexTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


    var external_react_ = __webpack_require__("react");

    var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"


    var asyncToGenerator_ = __webpack_require__("@babel/runtime/helpers/asyncToGenerator");

    var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_); // EXTERNAL MODULE: external "@babel/runtime/regenerator"


    var regenerator_ = __webpack_require__("@babel/runtime/regenerator");

    var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_); // CONCATENATED MODULE: ./src/sendBeacon.ts


    var sendBeacon = function sendBeacon(url, payload) {
      var headers = {
        // Hack for sendBeacon to work. Should be 'application/json'.
        type: 'text/plain'
      };
      var data = {
        query: "mutation weapiEvent($EventPayload: EventPayload!) { event( payload: $EventPayload ) }",
        operationName: 'weapiEvent',
        variables: {
          EventPayload: payload
        }
      };

      if (navigator.sendBeacon) {
        var blob = new Blob([JSON.stringify(data)], headers); // Note: this will return a 400 if any of the required fields aren't present, such as BCID or Carvana user ID.

        navigator.sendBeacon(url, blob);
      } else {
        fetch(url, {
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(data),
          keepalive: true
        }).then(function (response) {
          console.log('Clickstream event sent successfully', response.text);
        }).catch(function (error) {
          throw Error("Error: " + error);
        });
      }
    };
    /* harmony default export */


    var src_sendBeacon = sendBeacon; // EXTERNAL MODULE: external "uuid"

    var external_uuid_ = __webpack_require__("uuid"); // CONCATENATED MODULE: ./src/getCookie.js

    /* eslint-disable no-useless-escape */


    var getCookie = function getCookie(name) {
      function escape(s) {
        return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
      }

      var match = document.cookie.match(RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)"));
      return match ? match[1] : null;
    };
    /* harmony default export */


    var src_getCookie = getCookie; // CONCATENATED MODULE: ./src/envelope/getBrowserCookieId.ts

    var getBrowserCookieId_getBrowserCookieId = function getBrowserCookieId() {
      return src_getCookie('BrowserCookieId');
    };
    /* harmony default export */


    var envelope_getBrowserCookieId = getBrowserCookieId_getBrowserCookieId; // EXTERNAL MODULE: external "jwt-decode"

    var external_jwt_decode_ = __webpack_require__("jwt-decode");

    var external_jwt_decode_default = /*#__PURE__*/__webpack_require__.n(external_jwt_decode_); // CONCATENATED MODULE: ./src/envelope/getCarvanaUserId.ts


    var getCarvanaUserId_getCarvanaUserId = function getCarvanaUserId() {
      try {
        var cvIdToken = src_getCookie('CVIdToken');
        var decodedToken = external_jwt_decode_default()(cvIdToken) || {};
        return decodedToken.sub;
      } catch (e) {
        return undefined;
      }
    };
    /* harmony default export */


    var envelope_getCarvanaUserId = getCarvanaUserId_getCarvanaUserId; // CONCATENATED MODULE: ./src/envelope/correlationId.ts

    var correlationId_correlationId = Object(external_uuid_["v4"])();
    /* harmony default export */

    var envelope_correlationId = correlationId_correlationId; // CONCATENATED MODULE: ./src/envelope/getCurrentRoute.ts

    var getCurrentRoute = function getCurrentRoute() {
      return window.location.href;
    };
    /* harmony default export */


    var envelope_getCurrentRoute = getCurrentRoute; // CONCATENATED MODULE: ./src/envelope/getReferralUrl.ts

    var getReferralUrl = function getReferralUrl() {
      return document.referrer;
    };
    /* harmony default export */


    var envelope_getReferralUrl = getReferralUrl; // CONCATENATED MODULE: ./src/envelope/getBrowserResolution.ts

    var getBrowserResolution = function getBrowserResolution() {
      return window.innerWidth + "x" + window.innerHeight;
    };
    /* harmony default export */


    var envelope_getBrowserResolution = getBrowserResolution; // CONCATENATED MODULE: ./src/envelope/getScreenResolution.ts

    /* eslint-disable no-restricted-globals */

    var getScreenResolution = function getScreenResolution() {
      return screen.width + "x" + screen.height;
    };
    /* harmony default export */


    var envelope_getScreenResolution = getScreenResolution; // CONCATENATED MODULE: ./src/envelope/getUserAgent.ts

    var getUserAgent = function getUserAgent() {
      return window.navigator.userAgent;
    };
    /* harmony default export */


    var envelope_getUserAgent = getUserAgent; // CONCATENATED MODULE: ./src/envelope/index.ts

    var getEnvelope = /*#__PURE__*/function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(environment, project, track, eventName, correlationIdOverride, overrides) {
        var carvanaUserId;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return envelope_getCarvanaUserId();

              case 2:
                carvanaUserId = _context.sent;
                _context.t0 = Object;
                _context.t1 = {};
                _context.t2 = carvanaUserId && {
                  carvanaUser: {
                    id: carvanaUserId
                  }
                };
                _context.next = 8;
                return envelope_getBrowserCookieId();

              case 8:
                _context.t3 = _context.sent;
                _context.next = 11;
                return envelope_getBrowserResolution();

              case 11:
                _context.t4 = _context.sent;
                _context.next = 14;
                return envelope_getReferralUrl();

              case 14:
                _context.t5 = _context.sent;
                _context.next = 17;
                return envelope_getCurrentRoute();

              case 17:
                _context.t6 = _context.sent;
                _context.next = 20;
                return envelope_getUserAgent();

              case 20:
                _context.t7 = _context.sent;
                _context.t8 = {
                  cookieId: _context.t3,
                  resolution: _context.t4,
                  referralUrl: _context.t5,
                  url: _context.t6,
                  userAgent: _context.t7
                };
                _context.next = 24;
                return envelope_getScreenResolution();

              case 24:
                _context.t9 = _context.sent;
                _context.t10 = {
                  resolution: _context.t9
                };
                _context.t11 = {
                  browser: _context.t8,
                  device: _context.t10
                };
                _context.t12 = _context.t0.assign.call(_context.t0, _context.t1, _context.t2, _context.t11);
                _context.t13 = {
                  id: Object(external_uuid_["v4"])(),
                  name: eventName,
                  timestamp: new Date()
                };
                _context.t14 = Object.assign({
                  correlationId: correlationIdOverride || envelope_correlationId,
                  environment: environment,
                  project: project,
                  track: track
                }, overrides);
                return _context.abrupt("return", {
                  clickstream: _context.t12,
                  event: _context.t13,
                  metadata: _context.t14
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getEnvelope(_x, _x2, _x3, _x4, _x5, _x6) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var src_envelope = getEnvelope; // CONCATENATED MODULE: ./src/constructData.ts

    var constructData = function constructData(envelope, data, payloadMetaAttributes) {
      return Object.assign({}, envelope, {
        customAttributes: Object.assign({}, data, payloadMetaAttributes)
      });
    };
    /* harmony default export */


    var src_constructData = constructData; // CONCATENATED MODULE: ./src/startTracking.ts

    var startTracking_startTracking = function startTracking(env, url, track, project, correlationId, payloadMetaAttributes, debug) {
      var trackData = /*#__PURE__*/function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(data) {
          var _ref2, eventName, _ref2$customAttribute, customAttributes, _ref2$overrides, overrides, envelope, fullData, isProdLikeEnv;

          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _ref2 = data || {}, eventName = _ref2.eventName, _ref2$customAttribute = _ref2.customAttributes, customAttributes = _ref2$customAttribute === void 0 ? {} : _ref2$customAttribute, _ref2$overrides = _ref2.overrides, overrides = _ref2$overrides === void 0 ? {} : _ref2$overrides;
                  _context.next = 3;
                  return src_envelope(env, project, track, eventName, correlationId, overrides);

                case 3:
                  envelope = _context.sent;
                  fullData = src_constructData(envelope, customAttributes, payloadMetaAttributes);
                  isProdLikeEnv = env === 'production' || env === 'prod' || env === 'uat';

                  if (debug && !isProdLikeEnv) {
                    console.debug("Eventable clickstream payload for " + eventName + ": ", fullData);
                  } // Add eventName as a query param so it's easier to find in Chrome dev tools.


                  src_sendBeacon(url + "?" + eventName, fullData);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function trackData(_x) {
          return _ref.apply(this, arguments);
        };
      }();

      return trackData;
    };
    /* harmony default export */


    var src_startTracking = startTracking_startTracking; // CONCATENATED MODULE: ./src/constants/index.ts

    var prodUrl = 'https://apim.carvana.io/web-eventable/api/graph';
    var devUrl = 'https://apim.zagforward.com/web-eventable/api/graph'; // CONCATENATED MODULE: ./src/reactProvider/index.tsx

    var ANALYTICS_ENDPOINT = {
      production: prodUrl,
      prod: prodUrl,
      dev: devUrl,
      development: devUrl,
      test: 'https://apim.carvanatech.com/web-eventable/api/graph',
      uat: 'https://apim.cvuat.com/web-eventable/api/graph'
    };
    var defaultContext = {
      trackEvent: function trackEvent(_eventName, _customAttributes, _overrides) {}
    };
    var AnalyticsContext = Object(external_react_["createContext"])(defaultContext);

    var reactProvider_AnalyticsProvider = function AnalyticsProvider(_ref) {
      var children = _ref.children,
          environment = _ref.environment,
          track = _ref.track,
          projectName = _ref.projectName,
          _ref$correlationId = _ref.correlationId,
          correlationId = _ref$correlationId === void 0 ? '' : _ref$correlationId,
          _ref$payloadMetaAttri = _ref.payloadMetaAttributes,
          payloadMetaAttributes = _ref$payloadMetaAttri === void 0 ? {} : _ref$payloadMetaAttri,
          _ref$debug = _ref.debug,
          debug = _ref$debug === void 0 ? true : _ref$debug;
      var endpoint = ANALYTICS_ENDPOINT[environment] || ANALYTICS_ENDPOINT.dev;
      var trackData = Object(external_react_["useMemo"])(function () {
        return src_startTracking(environment, endpoint, track, projectName, correlationId, payloadMetaAttributes, debug);
      }, []);
      var trackEvent = Object(external_react_["useCallback"])(function (eventName, customAttributes, overrides) {
        trackData({
          eventName: eventName,
          customAttributes: customAttributes || {},
          overrides: overrides || {}
        });
      }, [trackData]);
      var value = Object(external_react_["useMemo"])(function () {
        return {
          trackEvent: trackEvent
        };
      }, [trackEvent]);
      return /*#__PURE__*/external_react_default.a.createElement(AnalyticsContext.Provider, {
        value: value
      }, children);
    };
    /* harmony default export */


    var reactProvider = AnalyticsContext; // EXTERNAL MODULE: ./src/contracts/weapiEventPayload.ts

    var weapiEventPayload = __webpack_require__("./src/contracts/weapiEventPayload.ts");

    var weapiEventPayload_default = /*#__PURE__*/__webpack_require__.n(weapiEventPayload); // CONCATENATED MODULE: ./src/index.ts

    /* concated harmony reexport default */


    __webpack_require__.d(__webpack_exports__, "default", function () {
      return src_startTracking;
    });
    /* concated harmony reexport AnalyticsProvider */


    __webpack_require__.d(__webpack_exports__, "AnalyticsProvider", function () {
      return reactProvider_AnalyticsProvider;
    });
    /* concated harmony reexport AnalyticsContext */


    __webpack_require__.d(__webpack_exports__, "AnalyticsContext", function () {
      return reactProvider;
    });
    /* concated harmony reexport ContextType */


    __webpack_require__.d(__webpack_exports__, "ContextType", function () {
      return (
        /* Cannot get final name for export "ContextType" in "./src/reactProvider/index.tsx" (known exports: AnalyticsProvider default, known reexports: ) */
        undefined
      );
    });
    /* concated harmony reexport WeapiEventPayload */


    __webpack_require__.d(__webpack_exports__, "WeapiEventPayload", function () {
      return weapiEventPayload_default.a;
    });
    /***/

  },

  /***/
  "@babel/runtime/helpers/asyncToGenerator":
  /***/
  function babelRuntimeHelpersAsyncToGenerator(module, exports) {
    module.exports = require("@babel/runtime/helpers/asyncToGenerator");
    /***/
  },

  /***/
  "@babel/runtime/regenerator":
  /***/
  function babelRuntimeRegenerator(module, exports) {
    module.exports = require("@babel/runtime/regenerator");
    /***/
  },

  /***/
  "jwt-decode":
  /***/
  function jwtDecode(module, exports) {
    module.exports = require("jwt-decode");
    /***/
  },

  /***/
  "react":
  /***/
  function react(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  "uuid":
  /***/
  function uuid(module, exports) {
    module.exports = require("uuid");
    /***/
  }
  /******/

});